import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: true,
})

@Injectable()
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    } else {
      return '';
    }
  }
}
